import { useTranslation } from "react-i18next";
import { OrganizationUserRoleType } from "../../data/redux/organizationReducer"

export const useRoles = () => {
    const { t } = useTranslation();
    return {
        getRoleName: (e: OrganizationUserRoleType) => {
            if (e == "OWNER") {
                return t("roleNameOWNER")
            } else if (e === "MEMBER") {
                return t("roleNameMEMBER")
            } else {
                return "-"
            }

        }
    }

}